<template>
    <div style="padding: 20px;">
        <div v-html="content"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            content: ''
        }
    },
    created() {
        this.getArticle(this.$route.params.gcode, this.$route.params.code)
    },
    methods: {
        getArticle(gcode, code) {
            this.$http.getAction(`/api/v1/sys/config/article/${gcode}/${code}`).then(res => {
                if(res.success) {
                    console.log(res.data)
                    this.content = this.$utils.escape2Html(res.data)
                }
            })
        }
    }
}
</script>